let leaveConfirmed = false;

/**
 * Leave this page for a fresh load of `to`, or of itself without one.
 *
 * The web app's account boundary (`AuthProvider`): a page holds one signed-in
 * account, and when that account's session ends or changes, the page is left
 * rather than tidied. Whatever the ended session still had going ends with the
 * page: a request still out, a queued write, a timer, a cache entry, a callback
 * yet to run. Tidying instead meant listing each of those and cancelling it,
 * and two review rounds each found one the list had missed, with the next
 * person to sign in on the machine receiving the previous account's work
 * (review of 0.2.0, 3 Oct).
 *
 * `confirmed` is for a leave the person has already agreed to, as sign-out
 * asks before it starts: the page's own "Leave site?" prompt
 * (`askBeforeLeaving`) is not put to them a second time, after the session has
 * already ended. Its own module so that tests can see it called.
 */
export function leavePage(to?: string, options: { confirmed?: boolean } = {}): void {
  if (options.confirmed) leaveConfirmed = true;
  if (to === undefined) window.location.reload();
  else window.location.assign(to);
}

/**
 * The `beforeunload` answer for a page with unsaved work: ask before it is left,
 * unless the person has already agreed to leave (`leavePage`).
 */
export function askBeforeLeaving(event: BeforeUnloadEvent): void {
  if (leaveConfirmed) return;
  event.preventDefault();
  // Chrome requires returnValue to be set; the string itself is ignored by
  // every modern browser.
  event.returnValue = '';
}
